import * as React from "react";

function SvgSearchOutlined(props) {
  return <svg viewBox="0 0 41 41" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.667 0C7.482 0 0 7.482 0 16.667c0 9.185 7.482 16.666 16.667 16.666 3.994 0 7.662-1.418 10.537-3.772l9.95 9.95a1.668 1.668 0 102.358-2.356l-9.951-9.951a16.578 16.578 0 003.772-10.537C33.333 7.482 25.852 0 16.667 0zm0 3.333C24.05 3.333 30 9.283 30 16.667 30 24.05 24.05 30 16.667 30A13.308 13.308 0 013.333 16.667c0-7.384 5.95-13.334 13.334-13.334z" /></svg>;
}

export default SvgSearchOutlined;